import React from 'react'
import PropTypes from 'prop-types'

const ReportTableColGroup = ({ gearlessColumns }) => {
  return (
    <colgroup>
      <col style={{ width: '50px' }} />  {/* No */}
      <col style={{ minWidth: '225px' }} /> {/* Vessel Name */}
      <col style={{ minWidth: '225px' }} /> {/* Buyer */}
      <col style={{ minWidth: '200px' }} /> {/* SR. Number */}
      <col style={{ minWidth: '200px' }} /> {/* Geared */}
      <col style={{ minWidth: '200px' }} /> {/* Ratu Giok */}
      {/* Gearless */}
      {gearlessColumns.length === 0 ? (
        <col style={{ width: '100px' }} />
      ) : (
        <>
          {gearlessColumns.map((col, i) => (
            <col
              key={`gearless-col-${col}-${i}`}
              style={{ minWidth: '150px' }}
            />
          ))}
        </>
      )}
      <col style={{ minWidth: '150px' }} /> {/* Total Gearless */}
      <col style={{ minWidth: '150px' }} /> {/* BL Qty */}
      <col style={{ minWidth: '150px' }} /> {/* BL Date */}
    </colgroup>
  )
}

ReportTableColGroup.propTypes = {
  gearlessColumns: PropTypes.array.isRequired,
}

export default ReportTableColGroup